const ReportPostSvg = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6.17917 17.0125L2.98833 13.8217C2.67583 13.5092 2.5 13.085 2.5 12.6433V7.35667C2.5 6.915 2.67583 6.49083 2.9875 6.17917L6.17833 2.98833C6.49083 2.67583 6.915 2.5 7.35667 2.5H12.6417C13.0842 2.5 13.5083 2.67583 13.8208 2.98833L17.0108 6.17833C17.3242 6.49167 17.5 6.91667 17.5 7.35917V12.6425C17.5 13.0842 17.3242 13.5075 17.0125 13.82L13.8217 17.0117C13.5092 17.3242 13.085 17.5 12.6425 17.5H7.35667C6.915 17.5 6.49083 17.3242 6.17917 17.0125V17.0125Z"
      stroke="#CE212B"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M4.79297 15.208L15.208 4.79297"
      stroke="#CE212B"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export default ReportPostSvg;
